import { QueryClient, keepPreviousData } from '@tanstack/react-query'
import { MINUTE_IN_MILLISECONDS } from '@vaultsfyi/common/constants'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      placeholderData: keepPreviousData,
      staleTime: 2 * MINUTE_IN_MILLISECONDS,
      gcTime: 10 * MINUTE_IN_MILLISECONDS,
      retry: 2,
      refetchOnWindowFocus: true,
      refetchOnMount: true,
      refetchOnReconnect: true,
      refetchIntervalInBackground: false,
    },
  },
})
